import { useState, useEffect, useReducer, useContext } from "react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const reducer = (state, action) => {
	if (action.type === "LOAD_WHATSAPPS") {
		const whatsApps = action.payload;

		return [...whatsApps];
	}

	if (action.type === "UPDATE_WHATSAPPS") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex] = whatsApp;
			return [...state];
		} else {
			return [whatsApp, ...state];
		}
	}

	if (action.type === "UPDATE_SESSION") {
		const whatsApp = action.payload;
		const whatsAppIndex = state.findIndex(s => s.id === whatsApp.id);

		if (whatsAppIndex !== -1) {
			state[whatsAppIndex].status = whatsApp.status;
			state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
			state[whatsAppIndex].qrcode = whatsApp.qrcode;
			state[whatsAppIndex].retries = whatsApp.retries;
			return [...state];
		} else {
			return [...state];
		}
	}

	if (action.type === "DELETE_WHATSAPPS") {
		const whatsAppId = action.payload;

		const whatsAppIndex = state.findIndex(s => s.id === whatsAppId);
		if (whatsAppIndex !== -1) {
			state.splice(whatsAppIndex, 1);
		}
		return [...state];
	}

	if (action.type === "RESET") {
		return [];
	}
};

const useWhatsApps = () => {
	const [whatsApps, dispatch] = useReducer(reducer, []);
	const [loading, setLoading] = useState(true);

	

	const { isAuth } = useContext(AuthContext) || {};

	const fetchWhatsApps = async () => {
		try {
			setLoading(true);
			const { data } = await api.get("/whatsapp");
			dispatch({ type: "LOAD_WHATSAPPS", payload: data || [] });
			setLoading(false);
		} catch (err) {
			setLoading(false);
			toastError(err);
		}
	};

	useEffect(() => {
		if (!isAuth) {
			dispatch({ type: "RESET" });
			return;
		}
		fetchWhatsApps();
	}, [isAuth]);

	useEffect(() => {
		const socket = openSocket();

		// O socket é COMPARTILHADO por toda a aplicação. socket.off("whatsapp")
		// sem passar a função remove os ouvintes de TODO MUNDO -- inclusive os
		// do provider que alimenta o "!" do menu. Bastava abrir e fechar o modal
		// de transferência (que também usa este hook) para o menu parar de
		// atualizar até o próximo F5. Por isso cada ouvinte tem nome e é
		// removido individualmente.
		const aoAtualizarWhatsapp = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
			}
			if (data.action === "delete") {
				dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
			}
		};

		const aoAtualizarSessao = data => {
			if (data.action === "update") {
				dispatch({ type: "UPDATE_SESSION", payload: data.session });
			}
		};

		socket.on("whatsapp", aoAtualizarWhatsapp);
		socket.on("whatsappSession", aoAtualizarSessao);

		return () => {
			socket.off("whatsapp", aoAtualizarWhatsapp);
			socket.off("whatsappSession", aoAtualizarSessao);
		};
	}, []);

	return { whatsApps, loading, fetchWhatsApps };
};

export default useWhatsApps;
